"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryParamsFromProductSearchQuery = void 0;
function queryParamsFromProductSearchQuery(productSearchQuery) {
    if (!productSearchQuery) {
        return undefined;
    }
    const filters = Object.assign(Object.assign({ 'filters[category]': productSearchQuery.categoryId }, (productSearchQuery.attributes || []).reduce((acc, attribute) => {
        switch (attribute.type) {
            case 'attributes':
                acc[`filters[${attribute.key || attribute.id}]`] =
                    attribute.values.join(`,`);
                break;
            case 'attributes:not':
                acc[`filters:not[${attribute.key}]`] = attribute.values.join(`,`);
                break;
            case 'boolean':
                acc[`filters[${attribute.key}]`] = attribute.value ? 'true' : 'false';
                break;
            default:
                console.error(`Unsupported filter type`, attribute);
        }
        return acc;
    }, {})), { 'filters[term]': productSearchQuery.term, 'filters[minPrice]': productSearchQuery.minPrice, 'filters[maxPrice]': productSearchQuery.maxPrice, 'filters[minReduction]': productSearchQuery.minReduction, 'filters[maxReduction]': productSearchQuery.maxReduction, 'filters[hasCampaignReduction]': productSearchQuery.hasCampaignReduction === undefined
            ? undefined
            : productSearchQuery.hasCampaignReduction.toString(), containsSearch: productSearchQuery.containsSearch ? 'true' : undefined, disableFuzziness: productSearchQuery.disableFuzziness ? 'true' : undefined });
    const definedFilters = {};
    for (const [key, value] of Object.entries(filters)) {
        if (value !== undefined && value !== null) {
            definedFilters[key] = value;
        }
    }
    return definedFilters;
}
exports.queryParamsFromProductSearchQuery = queryParamsFromProductSearchQuery;
